/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ timecode: NonNullable<unknown> }} Media_Import_Update_Incode_PromptInputs */

const en_media_import_update_incode_prompt = /** @type {(inputs: Media_Import_Update_Incode_PromptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Media incode detected (${i?.timecode}). Would you like to update the project incode?`)
};

const fr_media_import_update_incode_prompt = /** @type {(inputs: Media_Import_Update_Incode_PromptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Incode detecte (${i?.timecode}). Voulez-vous mettre a jour l'incode du projet ?`)
};

const de_media_import_update_incode_prompt = /** @type {(inputs: Media_Import_Update_Incode_PromptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Medien-Inkodierung erkannt (${i?.timecode}). Möchten Sie die Projekt-Inkodierung aktualisieren?`)
};

const it_media_import_update_incode_prompt = /** @type {(inputs: Media_Import_Update_Incode_PromptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rilevato codice multimediale (${i?.timecode}). Vuoi aggiornare il codice del progetto?`)
};

const ru_media_import_update_incode_prompt = /** @type {(inputs: Media_Import_Update_Incode_PromptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Обнаружен медиакод (${i?.timecode}). Хотите обновить код проекта?`)
};

const es_media_import_update_incode_prompt = /** @type {(inputs: Media_Import_Update_Incode_PromptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Se detectó un código de entrada de medios (${i?.timecode}). ¿Desea actualizar el código de entrada del proyecto?`)
};

const zh_cn2_media_import_update_incode_prompt = /** @type {(inputs: Media_Import_Update_Incode_PromptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`检测到媒体编码（${i?.timecode}）。您是否要更新项目编码？`)
};

const ja_media_import_update_incode_prompt = /** @type {(inputs: Media_Import_Update_Incode_PromptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`メディアインコードが検出されました (${i?.timecode})。プロジェクトのインコードを更新しますか?`)
};

const hi_media_import_update_incode_prompt = /** @type {(inputs: Media_Import_Update_Incode_PromptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`मीडिया इनकोड का पता चला (${i?.timecode})। क्या आप प्रोजेक्ट इनकोड को अपडेट करना चाहेंगे?`)
};

const pt_pt2_media_import_update_incode_prompt = /** @type {(inputs: Media_Import_Update_Incode_PromptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Codificação de mídia detectada (${i?.timecode}). Deseja atualizar a codificação do projeto?`)
};

/**
* | output |
* | --- |
* | "Media incode detected ({timecode}). Would you like to update the project incode?" |
*
* @param {Media_Import_Update_Incode_PromptInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_import_update_incode_prompt = /** @type {((inputs: Media_Import_Update_Incode_PromptInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Import_Update_Incode_PromptInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_media_import_update_incode_prompt(inputs)
	if (locale === "de") return de_media_import_update_incode_prompt(inputs)
	if (locale === "it") return it_media_import_update_incode_prompt(inputs)
	if (locale === "ru") return ru_media_import_update_incode_prompt(inputs)
	if (locale === "es") return es_media_import_update_incode_prompt(inputs)
	if (locale === "zh-CN") return zh_cn2_media_import_update_incode_prompt(inputs)
	if (locale === "ja") return ja_media_import_update_incode_prompt(inputs)
	if (locale === "hi") return hi_media_import_update_incode_prompt(inputs)
	if (locale === "pt-PT") return pt_pt2_media_import_update_incode_prompt(inputs)
	return en_media_import_update_incode_prompt(inputs)
});